export const UPDATE_CLIENT_POLICIES_CURRENT_CACHE_KEY =
  'UPDATE_CLIENT_POLICIES_CURRENT_CACHE_KEY';
export const GET_CLIENTSPOLICIES_API_REQUEST = 'GET_CLIENTSPOLICIES_API_REQUEST';
export const GET_CLIENTSPOLICIES_API_SUCCESS = 'GET_CLIENTSPOLICIES_API_SUCCESS';
export const GET_CLIENTSPOLICIES_API_ERROR = 'GET_CLIENTSPOLICIES_API_ERROR';
export const GET_NEXT_CLIENTSPOLICIES_SUCCESS = 'GET_NEXT_CLIENTSPOLICIES_SUCCESS';
